import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-edit',
  templateUrl: './edit.component.html',
  styleUrls: ['./edit.component.scss']
})
export class PaiementEditComponent implements OnInit {
  @Input() public paiement: any;
  
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /builds/eveasoft/lea/lea-front/src/app/shared/paiement/edit/edit.component.ts